import React,{useEffect, useState} from 'react'
import './checkbox.scss'
const Checkbox = ({label, onChange,defaultValue}) => {
    const [isCheck, setIsCheck] = useState(false)
    useEffect(()=>{
        setIsCheck(defaultValue)
    },[defaultValue])
    return (
        <div className='checkbox-block' onClick={()=>{
            setIsCheck(!isCheck)
            onChange(!isCheck)

        }}>
            <input type='checkbox' checked={isCheck} />
            <label>{label}</label>
        </div>
    )
}

export default Checkbox